/**
 * Observer Calls Page
 * - Daily call queue with Start Call button
 * - Call timer with 4-minute nudge
 * - Mandatory post-call notes form
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ObserverNav from '../components/ObserverNav';
import ObserverCallQueue from '../components/ObserverCallQueue';
import ObserverMakeCall from '../components/ObserverMakeCall';
import ObserverGenerateReport from '../components/ObserverGenerateReport';

const ObserverCalls = () => {
  const navigate = useNavigate();
  const [observerId, setObserverId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('observer_token');
    
    if (!token) {
      navigate('/observer/login');
      return;
    }
    
    // Get observer ID from localStorage
    const userStr = localStorage.getItem('observer_user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        setObserverId(user.id);
      } catch (e) {
        console.error('Error parsing observer user:', e);
      }
    }
    
    // Also try observer_id directly
    const directId = localStorage.getItem('observer_id');
    if (directId && !observerId) {
      setObserverId(directId);
    }
  }, [navigate, observerId]);

  if (!observerId) {
    return (
      <div className="min-h-screen bg-slate-50">
        <ObserverNav />
        <div className="pt-20 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-violet-600 mx-auto mb-4"></div>
            <p className="text-slate-500">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <ObserverNav />
      <main className="pt-20 pb-8 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-slate-800">My Calls</h1>
            <p className="text-slate-500">Place a call now or manage your daily queue</p>
          </div>
          
          <div className="mb-8">
            <ObserverMakeCall />
          </div>

          <div className="mb-8">
            <ObserverGenerateReport />
          </div>

          <ObserverCallQueue observerId={observerId} />
        </div>
      </main>
    </div>
  );
};

export default ObserverCalls;
